/* eslint-disable */
const state = {
  open: false,
  modalVisible: false,
  toastVisible: false,
  toastMessage: ''
}

const mutations = {
  SET_TOGGLE: (state, shouldOpen) => {
    if (typeof shouldOpen === 'boolean') {
      state.open = shouldOpen
    } else {
      state.open = !state.open
    }
  },
  SET_MODAL_VISIBLE: (state, shouldOpen) => {
    if (typeof shouldOpen === 'boolean') {
      state.modalVisible = shouldOpen
    } else {
      state.modalVisible = !state.modalVisible
    }
  },
  SET_TOAST_VISIBLE: (state, shouldOpen) => {
    if (typeof shouldOpen === 'boolean') {
      state.toastVisible = shouldOpen
    } else {
      state.toastVisible = !state.toastVisible
    }
  },
  SET_TOAST_MESSAGE: (state, msg) => {
    state.toastMessage = msg
  }
}

const actions = {
  // remove token
  updateToggle({ commit }, shouldOpen) {
    return new Promise(resolve => {
      commit('SET_TOGGLE', shouldOpen)
      resolve()
    })
  },
  updateModalVisible({ commit }, shouldOpen) {
    return new Promise(resolve => {
      commit('SET_MODAL_VISIBLE', shouldOpen)
      resolve()
    })
  },
  updateToastVisible({ commit }, toastInfo) {
    const { shouldOpen, msg } = toastInfo
    return new Promise(resolve => {
      // console.log('msgmsg', msg)
      commit('SET_TOAST_VISIBLE', shouldOpen)
      commit('SET_TOAST_MESSAGE', msg)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/onsen.js